import React from 'react';
import { Block, Centered, StyledText } from '../../styled';
import { Subtitle1, Subtitle2 } from '../../../typography';
import { Button } from '../../../button';
export const ErrorScreen = ({ error }) => {
    return (React.createElement(Block, null,
        React.createElement(Centered, { className: "centered" },
            React.createElement(StyledText, null,
                React.createElement(Subtitle1, null, error.message),
                React.createElement(Subtitle2, null, error.description)),
            error.action && (React.createElement(Button, { onClick: error.action, text: "Try again" }, "Try again")))));
};
